import i18n from 'services/base/i18n';

export default {
  title:        () => i18n.pgettext('Issues|Unknown', 'Unknown Issue'),
  description:  () => i18n.pgettext('Issues|Unknown', 'Unknown Issue'),

  kindTitle:    () => i18n.pgettext('Issues|Unknown|Kind', 'Unknown Issue Type'),
  kindSubtitle: () => i18n.pgettext('Issues|Unknown|Kind', 'Unrecognized by this version of the app'),
};
